
export const getLabels = (showHistory) => {
  if (showHistory) {
    return [
      {
        name: "Tipo",
        key: "Tipo",
        customStyle: {
          paddingInline: "5px",
          minWidth: "50px",
          maxWidth: "50px",
          textAlign: "center",
          justifyContent: "center",
        },
        customLabelStyle: {
          paddingInline: "5px",
          minWidth: "50px",
          maxWidth: "50px",
          textAlign: "center",
          justifyContent: "center",
        },
      },
      {
        name: "Cód.Portal",
        key: "Id",
        customStyle: {
          paddingInline: "5px",
          minWidth: "90px",
          maxWidth: "90px",
          textAlign: "center",
          justifyContent: "center",
        },
        customLabelStyle: {
          paddingInline: "5px",
          minWidth: "90px",
          maxWidth: "90px",
          textAlign: "center",
          justifyContent: "center",
        },
      },
      {
        name: "Cód.SAP",
        key: "CodigoSAP",
        customStyle: {
          paddingInline: "5px",
          minWidth: "90px",
          maxWidth: "90px",
          textAlign: "center",
          justifyContent: "center",
        },
        customLabelStyle: {
          paddingInline: "5px",
          minWidth: "90px",
          maxWidth: "90px",
          textAlign: "center",
          justifyContent: "center",
        },
      },
      {
        name: "Load",
        key: "Load",
        customStyle: {
          paddingInline: "5px",
          minWidth: "65px",
          maxWidth: "65px",
          textAlign: "center",
          justifyContent: "center",
        },
        customLabelStyle: {
          paddingInline: "5px",
          minWidth: "65px",
          maxWidth: "65px",
          textAlign: "center",
          justifyContent: "center",
        },
      },
      {
        name: "Prioridade",
        key: "ShipmentPriority",
        customStyle: {
          paddingInline: "5px",
          minWidth: "65px",
          maxWidth: "65px",
          textAlign: "center",
          justifyContent: "center",
        },
        customLabelStyle: {
          paddingInline: "5px",
          minWidth: "65px",
          maxWidth: "65px",
          textAlign: "center",
          justifyContent: "center",
        },
      },
      {
        name: "Origem",
        key: "Fornecedor",
        customStyle: {
          paddingInline: "5px",
          minWidth: "110px",
          flex: "1 1 11.2%",
          textAlign: "left",
          justifyContent: "left",
        },
        customLabelStyle: {
          paddingInline: "5px",
          minWidth: "110px",
          flex: "1 1 11.2%",
          textAlign: "left",
          justifyContent: "left",
        },
      },
      {
        name: "Destino",
        key: "Destino",
        customStyle: {
          paddingInline: "5px",
          minWidth: "110px",
          flex: "1 1 11.2%",
          textAlign: "left",
          justifyContent: "left",
        },
        customLabelStyle: {
          paddingInline: "5px",
          minWidth: "110px",
          flex: "1 1 11.2%",
          textAlign: "left",
          justifyContent: "left",
        },
      },
      {
        name: "Coleta",
        key: "DataColeta",
        customStyle: {
          paddingInline: "5px",
          minWidth: "100px",
          maxWidth: "100px",
          textAlign: "center",
          justifyContent: "center",
        },
        customLabelStyle: {
          paddingInline: "5px",
          minWidth: "100px",
          maxWidth: "100px",
          textAlign: "center",
          justifyContent: "center",
        },
      },
      {
        name: "Material",
        key: "Material",
        customStyle: {
          paddingInline: "5px",
          minWidth: "110px",
          flex: "1 1 11.2%",
          textAlign: "left",
          justifyContent: "left",
        },
        customLabelStyle: {
          paddingInline: "5px",
          minWidth: "110px",
          flex: "1 1 11.2%",
          textAlign: "left",
          justifyContent: "left",
        },
      },
      {
        name: "Data entrega",
        key: "DataEntrega",
        customStyle: {
          paddingInline: "5px",
          minWidth: "100px",
          maxWidth: "100px",
          textAlign: "center",
          justifyContent: "center",
        },
        customLabelStyle: {
          paddingInline: "5px",
          minWidth: "100px",
          maxWidth: "100px",
          textAlign: "center",
          justifyContent: "center",
        },
      },
      {
        name: "Quantidade",
        key: "Quantidade",
        customStyle: {
          paddingInline: "5px",
          minWidth: "90px",
          maxWidth: "90px",
          textAlign: "center",
          justifyContent: "center",
        },
        customLabelStyle: {
          paddingInline: "5px",
          minWidth: "90px",
          maxWidth: "90px",
          textAlign: "center",
          justifyContent: "center",
        },
      },
      {
        name: "Pendente",
        key: "SaldoPendente",
        customStyle: {
          paddingInline: "5px",
          minWidth: "90px",
          maxWidth: "90px",
          textAlign: "center",
          justifyContent: "center",
        },
        customLabelStyle: {
          paddingInline: "5px",
          minWidth: "90px",
          maxWidth: "90px",
          textAlign: "center",
          justifyContent: "center",
        },
      },
      {
        name: "QuantityConverted",
        key: "QuantityConverted",
        customStyle: {
          paddingInline: "5px",
          minWidth: "100px",
          maxWidth: "100px",
          textAlign: "center",
          justifyContent: "center",
        },
        customLabelStyle: {
          paddingInline: "5px",
          minWidth: "100px",
          maxWidth: "100px",
          textAlign: "center",
          justifyContent: "center",
          whiteSpace: "normal",
          overflowWrap: "break-word",
        },
      },
      {
        name: "UnitOfMeasure",
        key: "UnitOfMeasure",
        customStyle: {
          paddingInline: "5px",
          minWidth: "125px",
          maxWidth: "125px",
          textAlign: "center",
          justifyContent: "center",
        },
        customLabelStyle: {
          paddingInline: "5px",
          minWidth: "125px",
          maxWidth: "125px",
          textAlign: "center",
          justifyContent: "center",
          whiteSpace: "normal",
          overflowWrap: "break-word",
        },
      },
      {
        name: "Cancelado",
        key: "SaldoCancelado",
        customStyle: {
          paddingInline: "5px",
          minWidth: "90px",
          maxWidth: "90px",
          textAlign: "center",
          justifyContent: "center",
        },
        customLabelStyle: {
          paddingInline: "5px",
          minWidth: "90px",
          maxWidth: "90px",
          textAlign: "center",
          justifyContent: "center",
        },
      },
      {
        name: "Situação",
        key: "SituacaoDesc",
        customStyle: {
          paddingInline: "5px",
          minWidth: "65px",
          maxWidth: "65px",
          textAlign: "center",
          justifyContent: "center",
        },
        customLabelStyle: {
          paddingInline: "5px",
          minWidth: "65px",
          maxWidth: "65px",
          textAlign: "center",
          justifyContent: "center",
        },
      },
      {
        name: "Atualização",
        key: "UltimaAtualizacao",
        customStyle: {
          paddingInline: "5px",
          minWidth: "150px",
          maxWidth: "150px",
          textAlign: "center",
          justifyContent: "center",
        },
        customLabelStyle: {
          paddingInline: "5px",
          minWidth: "150px",
          maxWidth: "150px",
          textAlign: "center",
          justifyContent: "center",
        },
      },
    ];
  }

  return [
    {
      name: "Cód.Portal",
      key: "Id",
      customStyle: {
        paddingInline: "5px",
        minWidth: "90px",
        maxWidth: "90px",
        textAlign: "center",
        justifyContent: "center",
      },
      customLabelStyle: {
        paddingInline: "5px",
        minWidth: "90px",
        maxWidth: "90px",
        textAlign: "center",
        justifyContent: "center",
      },
    },
    {
      name: "Prioridade",
      key: "ShipmentPriority",
      customStyle: {
        paddingInline: "5px",
        minWidth: "65px",
        maxWidth: "65px",
        textAlign: "center",
        justifyContent: "center",
      },
      customLabelStyle: {
        paddingInline: "5px",
        minWidth: "65px",
        maxWidth: "65px",
        textAlign: "center",
        justifyContent: "center",
      },
    },
    {
      name: "Origem",
      key: "Fornecedor",
      customStyle: {
        paddingInline: "5px",
        minWidth: "186.33px",
        flex: "1 1 11.2%",
        textAlign: "left",
        justifyContent: "left",
      },
      customLabelStyle: {
        paddingInline: "5px",
        minWidth: "186.33px",
        flex: "1 1 11.2%",
        textAlign: "left",
        justifyContent: "left",
      },
    },
    {
      name: "Destino",
      key: "Destino",
      customStyle: {
        paddingInline: "5px",
        minWidth: "186.33px",
        flex: "1 1 11.2%",
        textAlign: "left",
        justifyContent: "left",
      },
      customLabelStyle: {
        paddingInline: "5px",
        minWidth: "186.33px",
        flex: "1 1 11.2%",
        textAlign: "left",
        justifyContent: "left",
      },
    },
    {
      name: "Coleta",
      key: "DataColeta",
      customStyle: {
        paddingInline: "5px",
        minWidth: "100px",
        maxWidth: "100px",
        textAlign: "center",
        justifyContent: "center",
      },
      customLabelStyle: {
        paddingInline: "5px",
        minWidth: "100px",
        maxWidth: "100px",
        textAlign: "center",
        justifyContent: "center",
      },
    },
    {
      name: "Material",
      key: "Material",
      customStyle: {
        paddingInline: "5px",
        minWidth: "186.33px",
        flex: "1 1 11.2%",
        textAlign: "left",
        justifyContent: "left",
      },
      customLabelStyle: {
        paddingInline: "5px",
        minWidth: "186.33px",
        flex: "1 1 11.2%",
        textAlign: "left",
        justifyContent: "left",
      },
    },
    {
      name: "Data entrega",
      key: "DataEntrega",
      customStyle: {
        paddingInline: "5px",
        minWidth: "100px",
        maxWidth: "100px",
        textAlign: "center",
        justifyContent: "center",
      },
      customLabelStyle: {
        paddingInline: "5px",
        minWidth: "100px",
        maxWidth: "100px",
        textAlign: "center",
        justifyContent: "center",
      },
    },
    {
      name: "Quantidade",
      key: "Quantidade",
      customStyle: {
        paddingInline: "5px",
        minWidth: "90px",
        maxWidth: "90px",
        textAlign: "center",
        justifyContent: "center",
      },
      customLabelStyle: {
        paddingInline: "5px",
        minWidth: "90px",
        maxWidth: "90px",
        textAlign: "center",
        justifyContent: "center",
      },
    },
    {
      name: "Pendente",
      key: "SaldoPendente",
      customStyle: {
        paddingInline: "5px",
        minWidth: "90px",
        maxWidth: "90px",
        textAlign: "center",
        justifyContent: "center",
      },
      customLabelStyle: {
        paddingInline: "5px",
        minWidth: "90px",
        maxWidth: "90px",
        textAlign: "center",
        justifyContent: "center",
      },
    },
    {
      name: "QuantityConverted",
      key: "QuantityConverted",
      customStyle: {
        paddingInline: "5px",
        minWidth: "100px",
        maxWidth: "100px",
        textAlign: "center",
        justifyContent: "center",
      },
      customLabelStyle: {
        paddingInline: "5px",
        minWidth: "100px",
        maxWidth: "100px",
        textAlign: "center",
        justifyContent: "center",
        whiteSpace: "normal",
        overflowWrap: "break-word",
      },
    },
    {
      name: "UnitOfMeasure",
      key: "UnitOfMeasure",
      customStyle: {
        paddingInline: "5px",
        minWidth: "125px",
        maxWidth: "125px",
        textAlign: "center",
        justifyContent: "center",
      },
      customLabelStyle: {
        paddingInline: "5px",
        minWidth: "125px",
        maxWidth: "125px",
        textAlign: "center",
        justifyContent: "center",
        whiteSpace: "normal",
        overflowWrap: "break-word",
      },
    },
    {
      name: "Situação",
      key: "SituacaoDesc",
      customStyle: {
        paddingInline: "5px",
        minWidth: "65px",
        maxWidth: "65px",
        textAlign: "center",
        justifyContent: "center",
      },
      customLabelStyle: {
        paddingInline: "5px",
        minWidth: "65px",
        maxWidth: "65px",
        textAlign: "center",
        justifyContent: "center",
      },
    },
    {
      name: "Atualização",
      key: "UltimaAtualizacao",
      customStyle: {
        paddingInline: "5px",
        minWidth: "150px",
        maxWidth: "150px",
        textAlign: "center",
        justifyContent: "center",
      },
      customLabelStyle: {
        paddingInline: "5px",
        minWidth: "150px",
        maxWidth: "150px",
        textAlign: "center",
        justifyContent: "center",
        wordWrap: "break-word",
        whiteSpace: "normal",
      },
    },
  ];
};
